import {PRODUCT_NAME_MAX_LENGTH} from "@/helpers/productName";

export const VAT_RATES = [0, 6, 12, 21];
const EXTERNAL_REFERENCE_MAX_LENGTH = 254;

export const TEXT = 'text';
export const LONG_TEXT = 'longText';
export const DECIMAL = 'decimal';
export const INTEGER = 'integer';
export const BOOLEAN = 'boolean';
export const VAT = 'vat';

export const CATALOG_SHEETS = [
    {
        name: 'Groups',
        rows: 'groups',
        columns: [
            {key: 'path', type: TEXT, required: true, path: true},
            {key: 'vatIn', type: VAT},
            {key: 'vatOut', type: VAT},
            {key: 'color', type: TEXT},
            {key: 'orderIndex', type: INTEGER},
            {key: 'userHidden', type: BOOLEAN},
            {key: 'webHidden', type: BOOLEAN},
            {key: 'kioskHidden', type: BOOLEAN},
            {key: 'imageUrl', type: LONG_TEXT},
            {key: 'externalReference', type: TEXT, maxLength: EXTERNAL_REFERENCE_MAX_LENGTH},
            {key: 'maxChoiceFree', type: INTEGER},
            {key: 'maxChoicePaid', type: INTEGER},
            {key: 'forceChoiceAmountFree', type: INTEGER},
            {key: 'forceChoiceAmountPaid', type: INTEGER},
        ],
    },
    {
        name: 'Products',
        rows: 'products',
        columns: [
            {key: 'name', type: TEXT, required: true, productName: true, maxLength: PRODUCT_NAME_MAX_LENGTH},
            {key: 'group', type: TEXT, required: true, path: true, source: 'Groups'},
            {key: 'priceVatInclIn', type: DECIMAL, required: true},
            {key: 'priceVatInclOut', type: DECIMAL},
            {key: 'vatIn', type: VAT},
            {key: 'vatOut', type: VAT},
            {key: 'barcodes', type: TEXT, multiple: true},
            {key: 'descriptionFr', type: LONG_TEXT},
            {key: 'descriptionNl', type: LONG_TEXT},
            {key: 'descriptionEn', type: LONG_TEXT},
            {key: 'color', type: TEXT},
            {key: 'imageUrl', type: LONG_TEXT},
            {key: 'externalReference', type: TEXT, maxLength: EXTERNAL_REFERENCE_MAX_LENGTH},
            {key: 'purchasePriceVatExcl', type: DECIMAL},
            {key: 'orderIndex', type: INTEGER},
            {key: 'userHidden', type: BOOLEAN},
            {key: 'webHidden', type: BOOLEAN},
            {key: 'kioskHidden', type: BOOLEAN},
            {key: 'dynamicPrice', type: BOOLEAN},
            {key: 'weightPrice', type: BOOLEAN},
            {key: 'optionLists', type: TEXT, multiple: true, optionListsOnly: true},
            {key: 'freeOptionGroups', type: TEXT, multiple: true, path: true},
            {key: 'paidOptionGroups', type: TEXT, multiple: true, path: true},
            {key: 'productId', type: INTEGER, exportOnly: true},
            {key: 'stock', type: DECIMAL, exportOnly: true},
        ],
    },
    {
        name: 'OptionLists',
        rows: 'optionLists',
        optionListsOnly: true,
        columns: [
            {key: 'name', type: TEXT, required: true},
            {key: 'nameFr', type: TEXT},
            {key: 'nameNl', type: TEXT},
            {key: 'nameEn', type: TEXT},
            {key: 'descriptionFr', type: LONG_TEXT},
            {key: 'descriptionNl', type: LONG_TEXT},
            {key: 'descriptionEn', type: LONG_TEXT},
            {key: 'minChoice', type: INTEGER},
            {key: 'maxChoice', type: INTEGER},
            {key: 'forceChoice', type: INTEGER},
        ],
    },
    {
        name: 'OptionListItems',
        rows: 'optionListItems',
        optionListsOnly: true,
        columns: [
            {key: 'list', type: TEXT, required: true, source: 'OptionLists'},
            {key: 'product', type: TEXT, required: true, source: 'Products'},
            {key: 'productGroup', type: TEXT, path: true, source: 'Groups'},
            {key: 'free', type: BOOLEAN},
            {key: 'without', type: BOOLEAN},
            {key: 'allowMultipleChoice', type: BOOLEAN},
            {key: 'maxChoice', type: INTEGER},
            {key: 'includeOptionLists', type: BOOLEAN},
            {key: 'priceIn', type: DECIMAL},
            {key: 'priceOut', type: DECIMAL},
            {key: 'priceAppIn', type: DECIMAL},
            {key: 'priceAppOut', type: DECIMAL},
            {key: 'priceWebIn', type: DECIMAL},
            {key: 'priceWebOut', type: DECIMAL},
            {key: 'priceKioskIn', type: DECIMAL},
            {key: 'priceKioskOut', type: DECIMAL},
        ],
    },
];
